'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Panels = require('../../main/jsx/Panels');

var _Panels2 = _interopRequireDefault(_Panels);

var _multimediaPanelsStacked = require('../../multimedia-panels-stacked');

var _multimediaPanelsStacked2 = _interopRequireDefault(_multimediaPanelsStacked);

var _socialInnovationPanel = require('../../../../molecules/social-innovation-panel');

var _socialInnovationPanel2 = _interopRequireDefault(_socialInnovationPanel);

var _clone = require('../../../../../utilities/clone');

var _clone2 = _interopRequireDefault(_clone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Utilities Imports


var ORGANISM_NAME = 'social-innovation';
var socInnoProps = (0, _clone2.default)(_Panels2.default.defaultProps);

var SocialInnovation = function (_React$Component) {
  _inherits(SocialInnovation, _React$Component);

  function SocialInnovation() {
    _classCallCheck(this, SocialInnovation);

    return _possibleConstructorReturn(this, (SocialInnovation.__proto__ || Object.getPrototypeOf(SocialInnovation)).apply(this, arguments));
  }

  _createClass(SocialInnovation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config;
      var headline = content.headline,
          footer = content.footer,
          items = content.items;


      delete socInnoProps.content.subheadline;
      delete socInnoProps.config.deviceImage;
      socInnoProps.config.theme = config.theme;
      socInnoProps.content.headline.text = headline.text;
      socInnoProps.content.footer.text = footer.text;
      socInnoProps.content.items = items;

      return _react2.default.createElement(_multimediaPanelsStacked2.default, _extends({ className: ORGANISM_NAME }, socInnoProps));
    }
  }]);

  return SocialInnovation;
}(_react2.default.Component);

exports.default = SocialInnovation;


SocialInnovation.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-blue', 'theme-background-color-white', 'theme-background-color-light']).isRequired
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    blogpost: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired
    }).isRequired,
    postlabel: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    footer: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_socialInnovationPanel2.default.propTypes).isRequired)
  })
};

SocialInnovation.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-color-white'
  },
  content: {
    headline: {
      text: '34 characters maximum'
    },
    blogpost: {
      url: 'https://www.paypal.com/stories/rest/blog-post/get-by-tag/social-innovation/us'
    },
    postlabel: {
      text: 'Social Innovation'
    },
    footer: {
      text: 'Latest News'
    },
    items: [_socialInnovationPanel2.default.defaultProps, _socialInnovationPanel2.default.defaultProps, _socialInnovationPanel2.default.defaultProps, _socialInnovationPanel2.default.defaultProps]
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/panels/social-innovation/jsx/SocialInnovation.js
// module id = 1129
// module chunks = 4